import { ResolverTag } from '@ps/web-core-enums';
import { StarsAutocomplete, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React, { useState } from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import useWizardJump from '@swf/core/hooks/useWizardJump';
import occupations from '@swf/generated/occupations.json';

import Container from '../Container/Container';
import InfoPrompt from '../InfoPrompt/InfoPrompt';

import {
  TXTWCL_If_your_job_title_is_not_liste_ELL,
  TXTWCL_Occupation,
  TXTWCL_Occupation_not_hereX,
  TXTWCL_Please_select_your_occupation__ELL,
  TXTWCL_To_continue_with_your_depositX_ELL,
  TXTWCL_WhatXs_your_occupationX,
  TXTWCL_You_may_be_required_to_verify__ELL
} from './Occupation.messages.json';
import { content, info, infoText, root } from './Occupation.scss';
import OccupationButtons from './components/OccupationButtons';

const Occupation: React.FC = () => {
  const { jumpBack } = useWizardJump();
  const onBackClick = () => jumpBack('#deposit.deposit-amount');

  const [shouldFocus, setShouldFocus] = useState(false);

  return (
    <Container
      headerProps={{
        title: <Translation {...TXTWCL_WhatXs_your_occupationX} />,
        buttons: { back: true, onBackClick }
      }}
      page={Occupation}
      helpSupportResolver
      showFooter
      pageTopTitle={<Translation {...TXTWCL_WhatXs_your_occupationX} />}
    >
      <div>
        <p className={content}>
          <Translation {...TXTWCL_To_continue_with_your_depositX_ELL} />
        </p>
        <Translation {...TXTWCL_You_may_be_required_to_verify__ELL} />

        <fieldset>
          <StarsAutocomplete
            id="profession"
            options={occupations}
            matchFrom="start"
            label={TXTWCL_Occupation}
            className={root}
            labelClassName={classNames(info)}
            labelContent={
              <InfoPrompt title={{ translation: TXTWCL_Occupation_not_hereX }}>
                <p className={infoText}>
                  <Translation
                    values={{
                      a: (msg: React.ReactNode) => (
                        <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
                      )
                    }}
                    {...TXTWCL_If_your_job_title_is_not_liste_ELL}
                  />
                </p>
              </InfoPrompt>
            }
            maxLength={50}
            validators={[required(TXTWCL_Please_select_your_occupation__ELL)]}
            shouldFocus={shouldFocus}
            showValidationTick={false}
          />
        </fieldset>
        <OccupationButtons onSearchAgainClick={setShouldFocus} />
      </div>
    </Container>
  );
};

Occupation.displayName = 'Occupation';

export default Occupation;
